import {Component, OnInit, Input} from '@angular/core';
import {Product} from '../models/product.model';


@Component({
  selector: 'app-product',
  templateUrl: './product.component.html'
})
export class ProductComponent implements OnInit {

  @Input()
  product: Product;

  @Input()
  storeLink: string;

  constructor() {}

  ngOnInit() {
    console.log("Rendering product: " + JSON.stringify(this.product,null,4));
  }

  encodedProductId() {
    return encodeURIComponent(this.product.id);
  }

}
